import { Button, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import Slider from '../../../slider/Slider';
import GoogleMap from '../../../google-map/GoogleMap';
import { generateUniqueId } from '../../../../utils';
import { AppSkinProps } from '../../../../types/decisions';

const AppCriteriaTypeGeo = ({
    id,
    importance,
    hideValues,
    hideImportance,
    onSliderChange,
    onTradeoffValueChange,
    showAddConstraint,
    value,
    variant,
    displayFullWidth,
    disabled = false,
}: {
    id: string;
    importance: number;
    hideValues?: boolean;
    hideImportance?: boolean;
    showAddConstraint?: boolean;
    onSliderChange: AppSkinProps['onSliderChange'];
    onTradeoffValueChange: (value: any, id: string, key: string) => void;
    variant: 'SingleField' | 'Map' | 'Agent';
    value: any;
    displayFullWidth: boolean;
    disabled?: boolean;
}) => {
    const onPointSelect = (items: {
        lat: number,
        lng: number,
        zipCode: string
    }[]) => {
        const firstItem = items[0];
        if (!firstItem) {
            return;
        }
        onTradeoffValueChange({ latitude: firstItem.lat, longitude: firstItem.lng }, id, '');
    };

    const customMapComponent = (
        <div style={{ width: displayFullWidth ? 700 : '100%' }}>
            <GoogleMap
                onPointSelect={onPointSelect}
                preselectedPoints={[ {
                    id: generateUniqueId(),
                    lat: +value.latitude,
                    lng: +value.longitude,
                    zipCode: '',
                } ]}
            />
        </div>
    );

    const zipComponents = {
        Default: customMapComponent,
        Map: customMapComponent,
        Agent: customMapComponent,
        SingleField: (
            <>
                <TextField
                    label="Lat"
                    defaultValue={value.latitude}
                    onBlur={(event) => {
                        onTradeoffValueChange(+event.target.value, id, 'latitude');
                        // onPointSelect([{ lat: +event.target.value, lng: value.longitude, zipCode: '' }])
                    }}
                    disabled={disabled}
                />
                <br/>
                <br/>
                <TextField
                    label="Lng"
                    defaultValue={value.longitude}
                    onBlur={(event) => {
                        onTradeoffValueChange(+event.target.value, id, 'longitude');
                        // onPointSelect([{ lat: value.latitude, lng: +event.target.value, zipCode: '' }])
                    }}
                    disabled={disabled}
                />
            </>
        ),
    };

    return (
        <div>
            {hideValues ? null : (
                <div style={{ marginBottom: 10 }}>
                    {zipComponents[variant]}
                </div>
            )}
            {hideImportance ? null : (
                <div>
                    <Slider
                        min={0}
                        max={100}
                        step={1}
                        defaultValue={importance}
                        leftText="Not Important"
                        rightText="Really Important"
                        onChangeCommitted={(_, value) => onSliderChange(value as number, id)}
                        disabled={disabled}
                    />
                </div>
            )}
            {!showAddConstraint ? null : (
                <div style={{ marginTop: 20 }}>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon/>}
                        size="small"
                        disabled={disabled}
                    >
                        Add Constraint
                    </Button>
                </div>
            )}
        </div>
    );
};

export default AppCriteriaTypeGeo;
